import { MenuDndItemsType } from "@/common/type/type";

export const initialMenuItems: MenuDndItemsType = [
  { id: "menu-1", content: "データ", type: "data" },
  { id: "menu-2", content: "トレンド", type: "trend" },
];
